import request from '@/utils/request'

// 粉丝昨天、今天统计
export function fanStatistics(params = {}) {
  return request({
    url: '/userStatistics/totalStatistics',
    method: 'get',
    params
  })
}

// 粉丝图标统计
export function fanIconStatistics(params = {}) {
  return request({
    url: '/userStatistics/chart',
    method: 'get',
    params
  })
}

// 订单统计
export function orderStatistics(params = {}) {
  return request({
    url: '/orderStatistics/totalStatistics',
    method: 'get',
    params
  })
}

// 订单图标统计
export function orderIconStatistics(params = {}) {
  return request({
    url: '/orderStatistics/chart',
    method: 'get',
    params
  })
}

// 公众号搜索展示
export function officialAccountSearchDisplay(params = {}) {
  return request({
    url: '/officialAccount/list',
    method: 'get',
    params
  })
}
